module.exports = __webpack_public_path__ + "img/lab-technician.02dc3deb.svg";